// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_try_it_button = /** @type {(inputs: {}) => string} */ () => {
	return `Try it yourself!`
};

const id_landing_try_it_button = /** @type {(inputs: {}) => string} */ () => {
	return `Cobalah sendiri!`
};

const ja_landing_try_it_button = /** @type {(inputs: {}) => string} */ () => {
	return `ぜひお試しください！`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_try_it_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_try_it_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_try_it_button", locale)
	if (locale === "en") return en_landing_try_it_button(inputs)
	if (locale === "id") return id_landing_try_it_button(inputs)
	return ja_landing_try_it_button(inputs)
};
export { landing_try_it_button as "landing.try_it_button" }